var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.$permissionAbility(_vm.SALARY_PAYSLIP_CREATE, _vm.permissions) ? _c('b-card', {
    attrs: {
      "title": "Generate Payslip"
    }
  }, [_c('validation-observer', {
    ref: "generateAllAttendanceValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.generateAllReport($event);
      }
    }
  }, [_c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3",
      "lg": "3",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "",
      "label-for": "empId"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "User",
      "vid": "empId"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('v-select', {
          staticClass: "mb-1 custom-font",
          attrs: {
            "id": "empId",
            "name": "empId",
            "options": _vm.userIdOption,
            "reduce": function reduce(item) {
              return item.id;
            },
            "label": "name",
            "placeholder": "Employee"
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function fn(data) {
              return [_c('UserSelect', {
                attrs: {
                  "user": data
                }
              })];
            }
          }], null, true),
          model: {
            value: _vm.selectEmpId,
            callback: function callback($$v) {
              _vm.selectEmpId = $$v;
            },
            expression: "selectEmpId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 104679384)
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "lg": "3",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mb-1 custom-font",
    attrs: {
      "options": _vm.filterDepartmentIdOption,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "Department"
    },
    on: {
      "input": _vm.changeDepartment
    },
    model: {
      value: _vm.selectDepartmentId,
      callback: function callback($$v) {
        _vm.selectDepartmentId = $$v;
      },
      expression: "selectDepartmentId"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "lg": "2",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center justify-content-around"
  }, [_vm.isReportGenerating ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 ml-1",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Report Generating .. ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 ml-1",
    attrs: {
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm._v(" Generate Payslip ")])]], 2)])])], 1)], 1)])], 1)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "12",
      "xs": "12"
    }
  }, [_c('b-card-actions', {
    attrs: {
      "title": "Filters",
      "action-collapse": ""
    }
  }, [_c('b-row', [_vm.$permissionAbility([_vm.SALARY_PAYSLIP_CREATE, _vm.SALARY_PAYSLIP_DISPATCH, _vm.SALARY_PAYSLIP_REVIEW, _vm.SALARY_PAYSLIP_SHOW], _vm.permissions) ? _c('b-col', {
    staticClass: "col",
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mb-1 custom-font",
    attrs: {
      "id": "empId",
      "name": "empId",
      "options": _vm.userAllOption,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "Employee"
    },
    on: {
      "input": _vm.loadItems
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(data) {
        return [_c('UserSelect', {
          attrs: {
            "user": data
          }
        })];
      }
    }], null, false, 3839851139),
    model: {
      value: _vm.filterUserId,
      callback: function callback($$v) {
        _vm.filterUserId = $$v;
      },
      expression: "filterUserId"
    }
  })], 1) : _vm._e(), _c('b-col', {
    staticClass: "col",
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "searchTerm"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Enter Date Range",
      "config": {
        mode: 'range'
      }
    },
    on: {
      "input": _vm.loadItems
    },
    model: {
      value: _vm.filterRangeDate,
      callback: function callback($$v) {
        _vm.filterRangeDate = $$v;
      },
      expression: "filterRangeDate"
    }
  })], 1)], 1), _vm.$permissionAbility([_vm.SALARY_PAYSLIP_CREATE, _vm.SALARY_PAYSLIP_DISPATCH, _vm.SALARY_PAYSLIP_REVIEW, _vm.SALARY_PAYSLIP_SHOW], _vm.permissions) ? _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mb-1 custom-font",
    attrs: {
      "options": _vm.paysSlipStatusOption,
      "reduce": function reduce(item) {
        return item.value;
      },
      "label": "title",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.loadItems
    },
    model: {
      value: _vm.paySlipStatus,
      callback: function callback($$v) {
        _vm.paySlipStatus = $$v;
      },
      expression: "paySlipStatus"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1), _c('b-modal', {
    staticClass: "full-screen-modal",
    attrs: {
      "id": "excel-data-modal",
      "title": "Excel Data",
      "size": 'xl',
      "hide-header-close": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "variant": "danger"
          },
          on: {
            "click": _vm.closeExcelDataModal
          }
        }, [_vm._v(" Close ")])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('b-table', {
    attrs: {
      "items": _vm.excelDataForView,
      "fields": _vm.fields,
      "striped": "",
      "responsive": "sm"
    },
    on: {
      "row-clicked": _vm.openSidebar
    },
    scopedSlots: _vm._u([{
      key: "cell(index)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.index + 1) + " ")];
      }
    }])
  })], 1)]), _c('b-modal', {
    attrs: {
      "id": "dispatch-modal",
      "centered": "",
      "title": "Disbursed Modal",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenDispatchModal
    }
  }, [_c('validation-observer', {
    ref: "dispatchValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.dispatchPayslip($event);
      }
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Select Tempalte",
      "label-for": "template"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "template",
      "vid": "template"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('v-select', {
          staticClass: "mb-1 custom-font",
          attrs: {
            "options": _vm.templatesOptions,
            "reduce": function reduce(item) {
              return item.id;
            },
            "label": "name",
            "placeholder": "Select Template"
          },
          model: {
            value: _vm.selectedTemplateId,
            callback: function callback($$v) {
              _vm.selectedTemplateId = $$v;
            },
            expression: "selectedTemplateId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.isDispatchSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1), _c('div', [_c('b-sidebar', {
    attrs: {
      "id": "sidebar-task-handler",
      "sidebar-class": "sidebar-lg",
      "visible": _vm.isPayrollHandlerSidebarActive,
      "bg-variant": "white",
      "shadow": "",
      "backdrop": "",
      "no-header": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var hide = _ref3.hide;
        return [_vm.isPayrollHandlerSidebarActive ? _c('payslip-sidebar-content', {
          ref: "payslipSidebarContent",
          attrs: {
            "default-currency": _vm.defaultCurrency,
            "user-data": _vm.userData,
            "pay-slip-data": _vm.paySlipData,
            "is-submitting": _vm.isSubmitting,
            "is-payslip-pdf-generating": _vm.isPayslipPdfGenerating,
            "total-payable-amount": _vm.totalPayableAmount
          },
          on: {
            "close": function close($event) {
              return _vm.closeSidebar(hide);
            },
            "submit": _vm.payslipValidationFormModal,
            "download-pdf": _vm.downloadPayslipPDF,
            "append-form-data": _vm.appendFormData
          }
        }) : _vm._e()];
      }
    }])
  })], 1), _c('b-card', [_c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('h4', [_vm._v("Payslips")]), _vm.selectedIds.length > 0 ? _c('div', {
    staticClass: "d-flex"
  }, [_vm.$permissionAbility([_vm.SALARY_PAYSLIP_CREATE, _vm.SALARY_PAYSLIP_DISPATCH, _vm.SALARY_PAYSLIP_REVIEW], _vm.permissions) ? _c('v-select', {
    staticClass: "mr-2",
    style: {
      width: '230px'
    },
    attrs: {
      "options": _vm.statusOptions,
      "label": "text",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.updatePayslipStatus
    },
    model: {
      value: _vm.selectedStatus,
      callback: function callback($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  }) : _vm._e(), _c('b-button', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.exportSelectedToExcel
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "FileTextIcon"
    }
  }), _vm._v(" Excel View (" + _vm._s(_vm.selectedIds.length) + " selected) ")], 1)], 1) : _vm._e()]), _c('vue-good-table', {
    attrs: {
      "style-class": "vgt-table table-custom-style striped",
      "line-numbers": false,
      "mode": "remote",
      "total-rows": _vm.totalRecords,
      "is-loading": _vm.isLoading,
      "rows": _vm.rows,
      "select-options": {
        enabled: _vm.$permissionAbility([_vm.SALARY_PAYSLIP_CREATE, _vm.SALARY_PAYSLIP_DISPATCH, _vm.SALARY_PAYSLIP_REVIEW, _vm.SALARY_PAYSLIP_SHOW], _vm.permissions) || false,
        selectOnCheckboxOnly: true,
        // only select when checkbox is clicked
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear'
      },
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'id',
          type: 'desc'
        }, {
          field: 'created_at',
          type: 'desc'
        }]
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange,
      "on-selected-rows-change": _vm.handleSelection
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row, _props$row4, _props$row4$user, _props$row5, _props$row6, _props$row7, _props$row8, _props$row9;
        return [props.column.field === 'format_user' ? _c('span', [(_props$row = props.row) !== null && _props$row !== void 0 && _props$row.user_id ? [_c('b-link', {
          attrs: {
            "href": _vm.getPageUrl(props.row.id)
          },
          on: {
            "click": function click($event) {
              var _props$row2, _props$row2$user, _props$row2$user$data, _props$row3;
              $event.preventDefault();
              return _vm.onShowPage(props === null || props === void 0 ? void 0 : (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : (_props$row2$user = _props$row2.user) === null || _props$row2$user === void 0 ? void 0 : (_props$row2$user$data = _props$row2$user.data) === null || _props$row2$user$data === void 0 ? void 0 : _props$row2$user$data.id, props === null || props === void 0 ? void 0 : (_props$row3 = props.row) === null || _props$row3 === void 0 ? void 0 : _props$row3.id);
            }
          }
        }, [_c('UserCard', {
          attrs: {
            "user": props === null || props === void 0 ? void 0 : (_props$row4 = props.row) === null || _props$row4 === void 0 ? void 0 : (_props$row4$user = _props$row4.user) === null || _props$row4$user === void 0 ? void 0 : _props$row4$user.data
          }
        })], 1)] : _vm._e()], 2) : _vm._e(), props.column.field === 'status' ? _c('span', [props !== null && props !== void 0 && (_props$row5 = props.row) !== null && _props$row5 !== void 0 && _props$row5.status ? _c('div', [props !== null && props !== void 0 && (_props$row6 = props.row) !== null && _props$row6 !== void 0 && _props$row6.status ? _c('b-badge', {
          staticClass: "mb-1",
          attrs: {
            "variant": "light-primary"
          }
        }, [_vm._v(" " + _vm._s(_vm.formatStatus(props === null || props === void 0 ? void 0 : (_props$row7 = props.row) === null || _props$row7 === void 0 ? void 0 : _props$row7.status)) + " ")]) : _vm._e(), _c('br'), _c('span', [_vm._v(_vm._s(_vm.formatDate(props === null || props === void 0 ? void 0 : (_props$row8 = props.row) === null || _props$row8 === void 0 ? void 0 : _props$row8.start_date)) + " - " + _vm._s(_vm.formatDate(props === null || props === void 0 ? void 0 : (_props$row9 = props.row) === null || _props$row9 === void 0 ? void 0 : _props$row9.end_date)))])], 1) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light-success"
          }
        }, [_vm._v(" Generated ")])], 1)]) : props.column.field === 'action' ? _c('span', [_c('span', [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "toggle-class": "text-decoration-none",
            "no-caret": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "text-body align-middle mr-25",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.downloadPayslipPDF(props.row.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "DownloadIcon"
          }
        }), _c('span', [_vm._v("Download")])], 1), _vm.$permissionAbility(_vm.SALARY_PAYSLIP_EDIT, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              var _props$row10, _props$row10$user, _props$row10$user$dat;
              return _vm.onShowPage(props === null || props === void 0 ? void 0 : (_props$row10 = props.row) === null || _props$row10 === void 0 ? void 0 : (_props$row10$user = _props$row10.user) === null || _props$row10$user === void 0 ? void 0 : (_props$row10$user$dat = _props$row10$user.data) === null || _props$row10$user$dat === void 0 ? void 0 : _props$row10$user$dat.id, props.row.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "EyeIcon"
          }
        }), _c('span', [_vm._v("Show")])], 1)] : _vm._e(), _vm.$permissionAbility([_vm.SALARY_PAYSLIP_CREATE, _vm.SALARY_PAYSLIP_DISPATCH, _vm.SALARY_PAYSLIP_REVIEW, _vm.SALARY_PAYSLIP_SHOW], _vm.permissions) ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.execlView(props.row.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "FileTextIcon"
          }
        }), _c('span', [_vm._v("Excel View")])], 1) : _vm._e(), _vm.$permissionAbility(_vm.SALARY_PAYSLIP_DELETE, _vm.permissions) ? _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onDelete(props.row.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', [_vm._v("Delete")])], 1) : _vm._e()], 2)], 1)]) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }